import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../../app-general';
import { EditUnitForm, TechnologyForCreationResponse,deleteUnitById} from '../../technologyoverlay';
import { ApiService } from '../../../../api.service';
import { appsettings } from '../../../../app-settings';
import { MapSyncProcess, UnitById } from '../../../../api';
import { GeneralMessageComponent } from '../../../../general-message/general-message.component';
import { TooltipPosition } from "@angular/material/tooltip";

@Component({
  selector: 'app-edit-outdoorspace',
  templateUrl: './edit-outdoorspace.component.html',
  styleUrls: ['./edit-outdoorspace.component.scss']
})
export class EditOutdoorspaceComponent implements OnInit {

  public editoutdoorspaceForm : FormGroup;
  watcher: Subscription;
  columns: number = 3;
  selectedCampus;
  campusinfo;
  newCampusInfo;
  addoutdoorbool : boolean = true;  
  SiteId = "1";
  SvgPoints;
  private _onDestroy: Subject<void> = new Subject<void>();
  editunitbool : boolean = true; 
  deleteUnitId;
  Outdoor_DeviceData;
  deviceEditflag;
  CampusName;
  BuildingName;
  FloorName;
  Description;
  Accuracy;
  MapSyncProcess;
  editoutdoordialogopen = 0;
  selectedUnitName;  
  device_Count = 0;
  maxSpaceId;
  matTooltipSpaceId = "The Space ID is an auto-number field that starts at (1) when the Approximate Space is first created. This field is editable.";
  matTooltipLocAccuracy = "Location Accuracy will be populated when available on signature server. This field is not editable.";
  positionOptions: TooltipPosition[] = [
  "after",
  "before",
  "above",
  "below",
  "left",
  "right",
  ];
  position = new FormControl(this.positionOptions[3]);
  checkCampusorZone = 0;
  checkApproximate = false;
  approxDescription = "";
  constructor(mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditOutdoorspaceComponent>,private router: Router,@Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,public dialog: MatDialog,private apiService: ApiService,public thiseditDialogRef: MatDialogRef<EditOutdoorspaceComponent>) {
    
    this.Outdoor_DeviceData = data.devicedata;
      this.SvgPoints = this.Outdoor_DeviceData.PolyPoints;
      this.deleteUnitId = this.Outdoor_DeviceData.UnitId;
      this.deviceEditflag = data.DeviceEdit;
      this.CampusName = this.Outdoor_DeviceData.CampusName;
      this.BuildingName = this.Outdoor_DeviceData.BuildingName;
      this.FloorName = this.Outdoor_DeviceData.FloorName;
      this.Description = this.Outdoor_DeviceData.Description;
      if(this.Outdoor_DeviceData.Accuracy != "")
        this.Accuracy = this.Outdoor_DeviceData.Accuracy+"%";    
      else
        this.Accuracy = this.Outdoor_DeviceData.Accuracy;  
      this.selectedUnitName = this.Outdoor_DeviceData.UnitName;
      this.device_Count = this.Outdoor_DeviceData.devicecount;
      this.maxSpaceId = this.Outdoor_DeviceData.SpaceId; 
      
      if(this.Description == "")
      {
        if(this.BuildingName == null)
          this.approxDescription = this.CampusName;
        else if(this.FloorName == null)
          this.approxDescription = this.BuildingName + "," + this.CampusName;
        else
          this.approxDescription = this.FloorName + "," + this.BuildingName + "," + this.CampusName;  
      }
      else
        this.approxDescription = this.Description;
      if(this.Outdoor_DeviceData.BuildId == 0)
        this.checkApproximate = false;
      else
        this.checkApproximate = true;
      
      this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        if (change) {           
          if (change.mqAlias == 'xs') {
            this.columns = 2;
          } 
          else {
            this.columns = 3;
          }                
        }
      });
  }

  ngOnInit() {
    this.editoutdoorspaceForm = new FormGroup({
      campus: new FormControl(''),
      campusId: new FormControl(''),
      buildId: new FormControl(''),
      building: new FormControl(''),
      floorId: new FormControl(''),
      floor: new FormControl(''),
      name:new FormControl('',[Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
      spaceId: new FormControl("", [ Validators.required, Validators.pattern("^[0-9-%]*"), Validators.min(1)]),  
      accuracy: new FormControl(''),
    });
    this.editoutdoorspaceForm.get('campus').disable();
    // this.editoutdoorspaceForm.get('building').disable();   
    // this.editoutdoorspaceForm.get('floor').disable();   
    this.editoutdoorspaceForm.get('accuracy').disable();
  }
  
public onCloseCancel = () => 
{      
    this.thisDialogRef.close('Cancel'); 
    if(!SessionCheck(this.router))
    {
        return;
    }   
}

public hasError = (controlName: string, errorName: string) =>
{
    this.editoutdoorspaceForm.controls[controlName].hasError(errorName);       
}  

editOutdoorSpacedata(editoutdoorform)
{
  if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      } 
      
      if (this.editoutdoorspaceForm.valid ) {                  
        this.updateUnit(editoutdoorform);
      }
}

openOutdoorEditdialog()
{
  try
    {        
      var _dialog = this.dialog;
      var outdoordata = this.Outdoor_DeviceData;
      let mapsyncinfo : MapSyncProcess = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey")
      };
      let editoutdoordata = JSON.stringify(outdoordata);
      this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
      .subscribe((MapSyncinfo: any[]) => { 
        this.MapSyncProcess = MapSyncinfo  
        if(this.MapSyncProcess == 1)
        {
          generateAlertMessage(_dialog, appsettings.MapSyncMsg);           
          return false;
        }          
        else
        {
          
            let outdoorDevicedata = {DeviceEdit:1,devicedata: JSON.parse(editoutdoordata)};            
            if(this.editoutdoordialogopen == 0)
            {
              let dialogRef = this.dialog.open(EditOutdoorspaceComponent, {
                disableClose: true,
                width: '38em',
                height:'610px',
                panelClass: 'myapp-no-padding-dialog',
                autoFocus: false,
                data: outdoorDevicedata
              });
              this.editoutdoordialogopen = 1;
              dialogRef.afterClosed().subscribe(result => {      
                this.editoutdoordialogopen = 0;  
                    
                if(result != "Cancel" && result != "outdoordelete")
                  this.getoutdoordetails(result);
                else if(result == "outdoordelete")  
                {
                  this.thiseditDialogRef.close();
                }
              })
            }
        }
    });
  }
    catch (err) {
          throw new Error('floorplans.component.ts' + ' - openOutdoorEditdialog() - ' + err.message);
        } 
}

getoutdoordetails(unitId)
{
  let unitbyid: UnitById = {
    siteId: this.SiteId,
    authKey: localStorage.getItem("Authkey"),
    unitId: parseInt(unitId)
  }
  this.technologyoverlayService.getUnitById(unitbyid).pipe(takeUntil(this._onDestroy))
  .subscribe((UnitByid: any[]) => {
    
    this.CampusName = UnitByid["apiReturn"][0].CampusName;
    this.BuildingName = UnitByid["apiReturn"][0].BuildingName;
    this.FloorName =UnitByid["apiReturn"][0].FloorName;
    this.Description = UnitByid["apiReturn"][0].Description;
    this.Accuracy = UnitByid["apiReturn"][0].Accuracy;
    this.selectedUnitName = UnitByid["apiReturn"][0].UnitName;
    this.Outdoor_DeviceData = UnitByid["apiReturn"][0];
    this.maxSpaceId = UnitByid["apiReturn"][0].SpaceId;
  });
}

private updateUnit = (editUnitFormValue) => {    
  try
  {   
      (document.activeElement as HTMLTextAreaElement).blur();   
      
      let _Description = "";        
      if(editUnitFormValue.description != "")
        _Description = editUnitFormValue.description.replace(/\s+/g, ' ').trim();
      else
        _Description = "";
          
      if (this.editoutdoorspaceForm.valid) {
        let saveclick = document.getElementById('btnsaveoutdooreditclick');
        saveclick.className = 'clseditoutdoorbutton mat-raised-button disablebtn';  
          let editunitdetails: EditUnitForm = {
            siteId:this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            unitId:parseInt(this.deleteUnitId),
            campusId:parseInt(editUnitFormValue.campusId),
            buildId: parseInt(editUnitFormValue.buildId),
            floorId: parseInt(editUnitFormValue.floorId), 
            unitName:editUnitFormValue.name.replace(/\s+/g, ' ').trim(),     
            description:_Description,//editUnitFormValue.description.replace(/\s+/g, ' ').trim(),
            spaceCategoryId:0,
            accuracy:'',//editUnitFormValue.accuracy.toString(),
            resOffLimits:0,
            spaceId: parseInt(editUnitFormValue.spaceId),
            chkAllday : 0,
            resStartHr : 0,
            resStartMi : 0,
            resEndHr : 0,
            resEndMi : 0
          }
          
            this.technologyoverlayService.updateUnit(editunitdetails).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : any[])=>{                          
            if(apiresponse["apiReturn"].toString() == "Success")
            { 	
              generateAlertMessage(this.dialog, 'Approximate Space edited successfully.'); 
              let saveclick = document.getElementById('btnsaveoutdooreditclick');
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                   
              this.thisDialogRef.close(this.deleteUnitId);
            }    
            else if(apiresponse["apiReturn"].toString() == "Fail")
            { 
              generateAlertMessage(this.dialog, 'Approximate Space edited failed.');	
              let saveclick = document.getElementById('btnsaveoutdooreditclick');
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                                     
              this.thisDialogRef.close();
            }              
            else if(apiresponse["apiReturn"] == "Invalid Auth Key")
            {    
                this.thisDialogRef.close('close');       
                let saveclick = document.getElementById('btnsaveoutdooreditclick');
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                          
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            } 
            else if(apiresponse["apiReturn"] == "Unit Name is empty")
            {                
              generateAlertMessage(this.dialog, 'Please enter Space Name');                  
              let saveclick = document.getElementById('btnsaveoutdooreditclick');
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                                 
              return; 
            }
            else if (apiresponse["apiReturn"] == "spaceId") {                            
              generateAlertMessage(this.dialog, "Space Id already exists, Please try with different Id.");       
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                   
              return;
            }
            else
            { 
              generateAlertMessage(this.dialog, "Space name '" + apiresponse["apiReturn"][0].UnitName + "' already exists.");
              let saveclick = document.getElementById('btnsaveoutdooreditclick');
              saveclick.className = 'clseditoutdoorbutton mat-raised-button';                                 
            }
          });
          
      }
  }
  catch (err) {
        throw new Error('edit-unit.component.ts' + ' - updateUnit() - ' + err.message);
    }             
}

openDeletedialog() { 
    
  try
  {   
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
        return;
    }        
    this.deleteUnit(this.deleteUnitId)
  }
  catch (err) {
        throw new Error('edit-unit.component.ts' + ' - openDeletedialog() - ' + err.message);
    }           
}

deleteUnit(deleteUnitId)
  {
    try
    {          
      var Device_Count="";
      var message="";      
          
      if(this.device_Count > 0)   
      {
          message = "It contains ";
          Device_Count = this.device_Count + " Devices.";
      }
      else if(this.device_Count == undefined)      
      {
        var DeviceCount = parseInt(localStorage.getItem("DeviceCount"));
        console.log("DeviceCount : " + DeviceCount)
        if(DeviceCount > 0)   
        {
            message = "It contains ";
            Device_Count = DeviceCount + " Devices.";
        }
      }
      
      var GeneralMessageData = {
        General_header:  "Delete Space ",                
        GeneralMessage:  "Are you sure you would like to delete this Space?<br> " + message + " <b>" + Device_Count + " </b>",
        General_first:  "Yes ",
        General_second:  "No"
      }    
      let dialogRef = this.dialog.open(GeneralMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: GeneralMessageData
      });     
      
      dialogRef.afterClosed().subscribe(result => {     
        if(result == "First")
        {                     
            this.DeleteUnitbyId(deleteUnitId)         
        }
        else
        {                
          dialogRef.close('Cancel');          
          return;
        }
      });
      
    }
    catch(err)
    {
        throw new Error('delete-resident-group.ts' + ' - deleteUnit() - ' + err.message);
    }   
  }
  
  DeleteUnitbyId(deleteUnitId)
  {
    var deleteunitById :deleteUnitById = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      unitId: parseInt(deleteUnitId)
    }

    this.technologyoverlayService.deleteUnit(deleteunitById).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : TechnologyForCreationResponse[])=>{           
        if(apiresponse["apiReturn"].toString() == "Success")
        { 	                
          generateAlertMessage(this.dialog, 'Space deleted successfully.');    
          this.thisDialogRef.close("outdoordelete");                        
        } 
        else if(apiresponse["apiReturn"].toString() == "Fail")
        {
          generateAlertMessage(this.dialog, 'Space deleted failed ');                    
        }
        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
        {    
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        }
        else
        {
          generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());                       
        } 
          // this.thisDialogRef.close();          
      }); 
  }

}
